import { defaultHttpClient } from '../../httpClient';
import type { GetHomeIconsResponse } from './types';

export const getHomeIcons = () => {
  return defaultHttpClient
    .request<GetHomeIconsResponse>({
      method: 'GET',
      url: '/api/v2/home/icons/',
    })
    .then(result => result.data);
};